@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.wrapper {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: auto;
  z-index: z-index(modal);
  padding: 48px 0;

  &.uncentered {
    align-items: flex-start;
  }
}

.underlay {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}

.root {
  @include blur;
  box-shadow: 0px 18px 64px 0px rgba(19, 21, 26, 0.22);
  border-radius: 20px;
  background: var(--light-80);
  z-index: 1;
  position: relative;
  outline: none;
  margin: auto;

  [data-autopilot-system-redesign='on'] & {
    border-radius: 16px;
    box-shadow: 0 2px 11px 0 rgba(0, 0, 0, 0.05);
    background: var(--light-100);
  }

  &.flex {
    display: flex;
    flex-direction: column;
  }

  &.withDefaultBg {
    background: var(--default-bg);
    backdrop-filter: unset;
  }

  &.uncentered {
    margin: 0 auto;
  }
}

.wrapper.xs {
  .root {
    width: 375px;
  }
}

.wrapper.xs-wide {
  .root {
    width: 422px;
  }
}

.wrapper.sm {
  .root {
    width: 560px;
  }

  &.blaze {
    .root {
      width: 650px;

      @include for-phone-only {
        width: 100%;
      }
    }
  }
}

.wrapper.md {
  .root {
    width: 888px;
  }
}

.wrapper.lg {
  .root {
    width: 1060px;
  }
}

.wrapper.fullscreen {
  padding: 0px;

  .root {
    width: 100%;
    min-height: 100%;
    border-radius: 0;
  }
}

@include for-phone-only {
  .wrapper.xs,
  .wrapper.sm,
  .wrapper.md,
  .wrapper.lg,
  .wrapper.fullscreen {
    padding: 0;

    .root {
      @include thinScrollbar;
      display: flex;
      flex-direction: column;
      width: 100%;
      min-height: 100%;
      border-radius: 0;
      margin-top: 0;
      overflow: hidden;
      overscroll-behavior-y: contain;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
}
